export function request({ type, startDate, endDate, page, sort }) {
    return {
        type: 'USER_GET_TRANSACTIONS_REQUEST',
        transactionType: type,
        startDate,
        endDate,
        page,
        sort
    };
}

export function error(errors) {
    return {
        type: 'USER_GET_TRANSACTIONS_ERROR',
        errors
    };
}

export function finish({ transactions, hasNextPage }) {
    return {
        type: 'USER_GET_TRANSACTIONS_FINISH',
        transactions,
        hasNextPage
    };
}

export function clear() {
    return {
        type: 'USER_GET_TRANSACTIONS_CLEAR'
    };
}
